import { render, staticRenderFns } from "./wsTooltip.vue?vue&type=template&id=3c740c12&scoped=true&"
import script from "./wsTooltip.vue?vue&type=script&lang=js&"
export * from "./wsTooltip.vue?vue&type=script&lang=js&"
import style0 from "./wsTooltip.vue?vue&type=style&index=0&id=3c740c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c740c12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSheet,VTooltip})
